import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { FC, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { IPartnerContactFormValues } from "src/entities/partners/model/types";
import { EConfirmModalType } from "src/shared/components";
import { useConfirmModal } from "src/shared/hooks";
import { useLazyGetPartnerContactsListQuery } from "../../model/api/partners";

interface IStatusesProps {
  isMainContact?: boolean;
}

export const Statuses: FC<IStatusesProps> = ({ isMainContact }) => {
  const [message, setMessage] = useState("");
  const { control, setValue, getValues } =
    useFormContext<IPartnerContactFormValues>();
  const { partner_id } = useParams<{ partner_id: string }>();
  const handleSubmitMainContact = (
    checked: boolean,
    closeModal?: () => void,
  ) => {
    closeModal && closeModal();
    setValue("is_main_contact", checked);
  };

  const [getContactsList, { isLoading }] = useLazyGetPartnerContactsListQuery();

  const { modal, showModal } = useConfirmModal({
    onResolve: ({ closeModal }) => {
      handleSubmitMainContact(true, closeModal);
      setMessage("");
    },
    confirmModalType: EConfirmModalType.WARNING,
    children: <Typography>{message}</Typography>,
  });

  async function handleMainContactSwitchChange(checked: boolean) {
    if (!checked) {
      handleSubmitMainContact(checked);

      return;
    }
    if (partner_id) {
      try {
        const data = await getContactsList({ partner_id }).unwrap();
        const firstName = getValues("firstname");
        const lastName = getValues("lastname");
        const mainContact = data?.find(
          ({ is_main_contact }) => is_main_contact,
        );
        if (!mainContact) {
          handleSubmitMainContact(checked);

          return;
        }
        const oldMainContactName =
          mainContact?.firstname + " " + mainContact?.lastname;
        const newMainContactName = firstName + " " + lastName;
        const message = `Сейчас основное контактное лицо - ${oldMainContactName}. Вы уверены, что хотите изменить его на ${newMainContactName}?`;
        setMessage(message);
        showModal();
      } catch (e) {
        enqueueSnackbar("Произошла ошибка", {
          variant: "error",
          handleClose: closeSnackbar,
        });
        console.log(e);
      }
    }
  }

  return (
    <Stack spacing={4} alignItems="flex-start">
      <Controller
        control={control}
        name="is_main_contact"
        render={({ field }) => (
          <FormControlLabel
            control={
              <Switch
                disabled={isMainContact || isLoading}
                {...field}
                checked={!!field.value}
                onChange={(e) => {
                  handleMainContactSwitchChange(e.target.checked);
                }}
              />
            }
            label="Основной контакт?"
          />
        )}
      />
      <Controller
        control={control}
        name="is_enabled"
        render={({ field }) => (
          <FormControlLabel
            control={<Switch {...field} checked={!!field.value} />}
            label="Активен?"
          />
        )}
      />
      {modal}
    </Stack>
  );
};
